import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-image-file-input', templateUrl: './choose-image-input.component.html', styleUrl: './choose-image-input.component.scss'
})
export class ChooseImageInputComponent {
    @Input() url: string;
    @Input() icon: string | File;
    fileName: string = '';

    @Output() fileChanged = new EventEmitter();

    onFileChanged(file) {
        this.fileName = file?.target?.files?.length > 0 ? file?.target?.files[0]?.name : '';

        if (this.fileName) {
            this.fileChanged.emit(file);
        }
    }
}
